import AdminReports from '@/pages/admin/AdminReports';

export default function AdminSupplierReports() {
  return <AdminReports mode="supplier" />;
}
